import f from "./design-system.es99.js";
import u from "./design-system.es58.js";
import { resolveComponent as t, openBlock as n, createBlock as a, withCtx as r, createVNode as p, mergeProps as k, createElementVNode as b, renderSlot as h, createCommentVNode as I, createTextVNode as T, toDisplayString as g } from "vue";
/* empty css                    */
import x from "./design-system.es128.js";
const C = {
  name: "DsTabHeaderLink",
  components: {
    TabHeaderItem: f,
    Icon: u
  },
  inheritAttrs: !1,
  props: {
    to: [String, Object],
    exact: Boolean,
    icon: String,
    label: String
  }
}, H = ["href"];
function S(o, v, e, L, N, V) {
  const c = t("Icon"), i = t("TabHeaderItem"), m = t("RouterLink");
  return n(), a(m, {
    to: e.to,
    custom: ""
  }, {
    default: r(({
      href: l,
      navigate: s,
      isActive: d,
      isExactActive: _
    }) => [
      p(i, k(o.$attrs, {
        active: e.exact ? _ : d,
        onClick: s
      }), {
        default: r(() => [
          b("a", {
            href: l,
            class: "tab-header-link-link"
          }, [
            h(o.$slots, "default", {}, () => [
              e.icon ? (n(), a(c, {
                key: 0,
                name: e.icon
              }, null, 8, ["name"])) : I("", !0),
              T(" " + g(e.label), 1)
            ], !0)
          ], 8, H)
        ]),
        _: 2
      }, 1040, ["active", "onClick"])
    ]),
    _: 3
  }, 8, ["to"]);
}
const w = /* @__PURE__ */ x(C, [["render", S], ["__scopeId", "data-v-5723cb4d"]]);
export {
  w as default
};
//# sourceMappingURL=design-system.es100.js.map
